import { useEffect, useMemo, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from "../../components/firebase";
// Важно: db должен экспортироваться из твоего ./firebase (где у тебя auth)

function microsToUsdNumberSafe(microsStr) {
  try {
    const bi = BigInt(String(microsStr || "0"));
    // micros = 1e6
    // Для UI нам достаточно number. Если будет очень большой баланс — можно вернуть string.
    return Number(bi) / 1e6;
  } catch {
    return 0;
  }
}

function clamp0(n) {
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function useAccountUsdBalances() {
  const [fbUser, fbLoading] = useAuthState(auth);

  const [loading, setLoading] = useState(true);
  const [totalUsd, setTotalUsd] = useState(0);
  const [availableUsd, setAvailableUsd] = useState(0);

  useEffect(() => {
    if (fbLoading) return;
    if (!fbUser?.uid) {
      setLoading(false);
      setTotalUsd(0);
      setAvailableUsd(0);
      return;
    }

    setLoading(true);

    const ref = doc(db, "users", fbUser.uid);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const data = snap.exists() ? snap.data() : {};

        // Твой текущий источник истины после депозитов:
        // users/{uid}.balance.usdtMicros (string)
        const bal = data?.balance || {};

        const total = microsToUsdNumberSafe(bal.usdtMicros);

        // Если позже добавишь "locked" / "reserved" — будет работать без переделок:
        const locked =
          microsToUsdNumberSafe(bal.lockedUsdtMicros) ||
          microsToUsdNumberSafe(bal.reservedUsdtMicros) ||
          0;

        const avail = clamp0(total - locked);

        setTotalUsd(clamp0(total));
        setAvailableUsd(avail);
        setLoading(false);
      },
      () => {
        setTotalUsd(0);
        setAvailableUsd(0);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [fbUser?.uid, fbLoading]);

  return useMemo(
    () => ({
      loading,
      totalUsd,
      availableUsd,
      uid: fbUser?.uid || null,
    }),
    [loading, totalUsd, availableUsd, fbUser?.uid]
  );
}
 